import { ProductionJobStatus } from "../enums/production-job-status";
import { ProductionJobType } from "../enums/production-job-type";
import { IMetricGroup } from "../shared/metric-interface";

export class ScheduleMetric implements IMetricGroup {

    public id : number = 0;

    public type : ProductionJobType = ProductionJobType.NotApplicable;
        
    public quantity : number = 0;

    public status : ProductionJobStatus = ProductionJobStatus.Open;

}
